import { DrawerComponent } from '~/shared/ui/Drawer'
import { Content } from './Content'
import { FormValues } from './Content/model'

type RentalServicesDrawerProps = {
  isShow: boolean
  onClose: () => void
  onSuccess: (formValues: FormValues) => void
}

export function RentalServicesDrawer({
  isShow,
  onClose,
  onSuccess,
}: RentalServicesDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content onSuccess={onSuccess} />
    </DrawerComponent>
  )
}
